import { useState } from "react";
import { ArrowLeft, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { IMG } from "@/data/vomarcData";

export function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("vision@vomarc.com");
  const [password, setPassword] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    const ok = await onLogin(email, password);
    if (ok) setPassword("");
  };

  return (
    <main className="admin-page dark-admin" data-testid="admin-login-page">
      <a className="admin-back-floating" href="/" data-testid="admin-login-back-link"><ArrowLeft size={14} /> Back to VOMARC</a>
      <form className="admin-login-card dark-admin-card" onSubmit={submit} data-testid="admin-login-form">
        <div className="admin-brand-row">
          <img className="brand-mark brand-mark-img" src={IMG.logo} alt="VOMARC logo" data-testid="admin-brand-mark" width="64" height="64" />
          <Lock size={18} className="admin-login-icon" data-testid="admin-login-lock-icon" />
        </div>
        <h1 data-testid="admin-login-title">Administration Login</h1>
        <p data-testid="admin-login-copy">Private VOMARC control area for website content, app links, images, demo and investor enquiries.</p>
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Admin email" data-testid="admin-login-email-input" />
        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-login-password-input" />
        <Button className="primary-cta full" type="submit" data-testid="admin-login-submit-button"><Lock size={17} /> Login</Button>
      </form>
    </main>
  );
}
